// 세리사무소 포털 상단바 — 브랜드는 세무대리인의 것이다 (기획서 6.1).
//
// 호스트 TopNav 와 다른 점이 셋이다:
//   · 좌상단이 세무법인의 로고·법인명이고, 프로그램사는 'Powered by' 한 줄로 물러난다.
//     화이트라벨이 이 서비스의 전제라, 상단바를 공용으로 쓰면 그 전제가 깨진다.
//   · 회사 컨텍스트 칩 — 수임기업에 진입하면 상주한다. 지금 누구의 데이터를 보고 있는지
//     한순간도 헷갈리지 않게 하는 것이 목적이다(세무대리 업무의 최대 사고 원인).
//   · 모듈 탭이 없다. 이동은 우측 사이드바에서 일어난다.
//
// 포털 전환 토글은 그대로 둔다 — 이 껍데기에서 기본 포털로 돌아갈 길이 여기뿐이다.
import React from 'react';
import { setPortal } from '../../lib/portal';
import { useAuth } from '../../context/AuthContext';
import { useZeirishi } from '../../pages/Home/Home.zeirishi.context';
import { companyOf } from '../../pages/Home/Home.zeirishi.data';
import { CLIENT_TOTAL } from './Sidebar.zeirishi.data';
import styles from './Layout.zeirishi.module.css';

/** 화이트라벨 대상 — 나중에 로그인 사용자의 소속에서 받아온다 */
const FIRM = { mark: 'JD', name: '세무법인 정담', by: 'Powered by Smart J' };

/** 시안 기준일 — 업무 데이터가 이 날짜 기준의 목업이라 화면도 같은 날을 가리킨다 */
const TODAY_LABEL = '2026. 9. 16 (수)';

export default function TopNavZeirishi() {
  const { user } = useAuth();
  const { currentCo, setCurrentCo, toast, view, setView, gisuOptions, comOptions, gisu, setGisu, comSq, setComSq } = useZeirishi();
  const co = currentCo ? companyOf(currentCo) : null;

  return (
    <header className={styles.topbar}>
      <div className={styles.brand}>
        <span className={styles.mk}>{FIRM.mark}</span>
        <span>
          <span className={styles.brandNm}>{FIRM.name}</span>
          <span className={styles.brandPw}>{FIRM.by}</span>
        </span>
      </div>

      <div className={styles.spacer} />

      {/* 회사 컨텍스트 — 진입 중일 때만 */}
      {co && (
        <div className={styles.ctxchip}>
          <span>{co.nm}</span>
          <span className={styles.ctxSm}>ERP 진입 중</span>
          <button
            type="button"
            onClick={() => { setCurrentCo(null); toast('수임기업 컨텍스트에서 나왔습니다'); }}
          >
            나가기
          </button>
        </div>
      )}

      {/* 기수·회사 선택 — 보기 전환과 같은 알약 톤. 어느 기수의 어느 회사를 보는지 상단에 상주시킨다. */}
      <div className={styles.psel}>
        <label className={styles.pselItem}>
          <span className={styles.vl}>기수</span>
          <select
            value={gisu}
            aria-label="기수 선택"
            onChange={e => setGisu(Number(e.target.value))}
          >
            {gisuOptions.map(o => <option key={o.gisu} value={o.gisu}>{o.label}</option>)}
          </select>
        </label>
        <span className={styles.pselDiv} />
        <label className={styles.pselItem}>
          <span className={styles.vl}>회사</span>
          <select
            value={comSq}
            aria-label="회사 선택"
            onChange={e => setComSq(Number(e.target.value))}
          >
            {comOptions.map(o => <option key={o.comSq} value={o.comSq}>{o.nm}</option>)}
          </select>
        </label>
      </div>

      {/* 보기 전환 — 기획서 5.1 이 "v8·v9 는 순서만 다르니 역할별 설정 하나로 합칠 수 있다"고
          한 그 설정이다. 담당 세무사는 업무를, 대표·파트너는 수익을 먼저 본다. */}
      <div className={styles.vsw} title="화면에 무엇을 먼저 띄울지 고릅니다">
        <span className={styles.vl}>보기</span>
        <button
          type="button"
          className={view === 'work' ? styles.vswOn : undefined}
          onClick={() => { setView('work'); toast('오늘의 업무를 먼저 보여 드립니다'); }}
        >
          업무 우선
        </button>
        <button
          type="button"
          className={view === 'rev' ? styles.vswOn : undefined}
          onClick={() => { setView('rev'); toast('수익 기회와 성과를 먼저 보여 드립니다'); }}
        >
          수익 우선
        </button>
      </div>

      <span className={styles.tbTxt}>수임기업 {CLIENT_TOTAL}</span>
      <span className={styles.tbTxt}>{TODAY_LABEL}</span>

      <button type="button" className={styles.ib} title="알림" onClick={() => toast('알림함은 아직 연결되지 않았습니다')}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.7 21a2 2 0 0 1-3.4 0" />
        </svg>
        <span className={styles.nd} />
      </button>

      {/* 기본 포털로 돌아가는 길 — 이 껍데기에는 호스트 네비게이션이 없다 */}
      <button
        type="button"
        className={styles.portalBtn}
        title="기본 포털로 전환"
        onClick={() => setPortal('default')}
      >
        기본 포털로
      </button>

      <span className={styles.av} title={user ? user.name : undefined}>
        {user && user.name ? user.name.slice(0, 1) : '?'}
      </span>
    </header>
  );
}
